<script lang="ts">
    import { onMount } from "svelte"
    import { apiBaseOverride } from "../store"
    import MedialibImage from "./MedialibImage.svelte"
    import blocks from "./blocks"
    export let block: ContentBlock
    export let apiBase: string = null
    if (apiBase) {
        $apiBaseOverride = apiBase
    }

    $: blockComponent = blocks[block.type] || blocks.default
    onMount(() => {
        // dynamically get height of h1 andset placeholder height to exactly that
        const h1 = document.querySelector("h1")
        const placeholder = document.querySelector(".placeholder")
        if (h1 && placeholder) {
            placeholder.style.height = `${h1.clientHeight}px`
        }
    })
</script>

<section
    data-type="{block.type}"
    class:paddingExtended="{block?.background?.padding == 'extended'}"
    class:negativeMargin="{block?.background?.padding == 'negative'}"
    class="{blockComponent?.sectionClass} {block.background?.color ? block.background.color : 'normal'}"
>
    <div class="wrapper">
        {#if block.headline || block.subline}
            <div class="container">
                <!-- Überschrift Element -->
                {#if block.headline}
                    {#if block.headlineH1}
                        <h1 class="top">
                            <span>
                                <MedialibImage id="{block?.headlineIcon}" />{block.headline}
                            </span>
                        </h1>
                        <div class="placeholder"></div>
                    {:else}
                        <h2>{block.headline}</h2>
                    {/if}
                {/if}
                {#if block.subline}
                    <h3>{block.subline}</h3>
                {/if}
            </div>
        {/if}
        <div class="component">
            <svelte:component this="{blockComponent.component}" {block} />
        </div>
    </div>
</section>

<style lang="less">
    section {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        gap: 24px;
        width: 100%;
        h2 {
            padding-bottom: 24px;
        }

        .placeholder {
            width: 100%;
            margin-bottom: var(--default-gap);
        }
        .wrapper {
            max-width: var(--normal-max-width);
            width: 100%;
            .component,
            h2,
            h3 {
                @media (max-width: 1400px) {
                    margin: 0px var(--horizontal-default-margin);
                }
            }
        }
    }
    :global .component {
        .textcolumn {
            a {
                color: rgb(226, 108, 14) !important;
            }
        }
    }
</style>
